/**
 * Extracts a human-readable message from an unknown error value.
 * Handles axios error responses (data.error, data.message, data.title, data.detail),
 * plain Error objects, and anything else by falling back to a provided default.
 */
export function extractErrorMessage(err: unknown, fallback = 'An unexpected error occurred.'): string {
  if (err == null) return fallback;

  // Axios-style error with a response body
  if (typeof err === 'object' && 'response' in err) {
    const data = (err as any).response?.data;
    if (data) {
      const field = data.error || data.message || data.detail || data.title;
      if (typeof field === 'string' && field.length > 0) return field;
      if (typeof data === 'string' && data.length > 0) return data;
    }
  }

  // Plain Error or anything with a .message
  if (typeof err === 'object' && 'message' in err) {
    const msg = (err as any).message;
    if (typeof msg === 'string' && msg.length > 0) return msg;
  }

  return fallback;
}
